// extracted by mini-css-extract-plugin
export var video = "recipe-video-preview-module--video--874d7";
export var videoPreview = "recipe-video-preview-module--video-preview--1d2cc";